<app-details-wrapper [title]="selectedClassification()?.name" (onBackClicked)="handleBackClick()">
  <div
    class="tw-flex tw-flex-col tw-gap-3 tw-rounded-lg tw-pl-3 tw-pr-3 tw-pb-3 tw-bg-dt-surface-elevated sm:tw-min-h-screen"
  >
    <!-- Linked Transactions -->
    <div class="tw-rounded-xl tw-p-4 tw-bg-dt-surface-card">
      <app-widget
        [title]="('myTransactions' | i18n) + ' (' + linkedTransactionCount() + ')'"
        [iconName]="'form'"
      >
      </app-widget>
    </div>

    <!-- Classification Detail -->
    <div class="tw-rounded-xl tw-p-4 tw-bg-dt-surface-card">
      <app-widget
        [title]="'classificationDetails' | i18n"
        [iconName]="'document'"
        class="tw-relative"
      >
        <div
          class="tw-grid tw-grid-cols-[minmax(120px,auto)_1fr] tw-gap-x-3 tw-gap-y-7 tw-items-center"
        >
          <label class="category-details-label">{{ "classificationName" | i18n }}</label>
          <span class="tw-text-base tw-text-dt-text-headings">
            {{ selectedClassification()?.name }}
          </span>
        </div>
        @if (selectedClassificationId() !== DEFAULT_CLASSIFICATION_ID) {
          <div class="tw-absolute tw-right-0 tw-top-0 tw-p-3">
            <button
              type="button"
              [attr.aria-label]="'editClassification' | i18n"
              (click)="editClassification()"
              class="tw-bg-dt-surface-elevated tw-rounded-2xl tw-p-1.5"
            >
              <icon
                [name]="'edit'"
                [currentColor]="'primary'"
                [size]="4"
                class="tw-rounded-2xl tw-bg-dt-surface-card tw-p-3"
              ></icon>
            </button>
          </div>
        }
      </app-widget>
    </div>
  </div>

  @if (selectedClassificationId() !== DEFAULT_CLASSIFICATION_ID) {
    <div class="tw-w-1/2 tw-mt-3 sm:tw-w-full sm:tw-p-4">
      <!-- A real button (was a clickable <div>) so it's reachable with Tab. -->
      <button
        type="button"
        (click)="deleteClassification()"
        class="tw-p-0 tw-text-left tw-text-dt-text-error tw-cursor-pointer"
      >
        {{ "deleteClassification" | i18n }}
      </button>
    </div>
  }
</app-details-wrapper>
